import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import { get_donation_by_id, update_donation_by_id, get_masked_card } from "../api/donations_api";
import { useDonationLogic } from "./useDonationLogic";
import DonationForm from "./DonationForm";
import "../styles/AddDonation.css";

const UpdateDonation = () => {
    const { donationId, donorId } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        amount: "", currency: "ILS", paymentMethod: "credit", status: "pending" 
    });
    const [error, setError] = useState(null);

    
    const handleSubmit = async (data) => {
        try {
            await update_donation_by_id(donationId, data);
            alert("התרומה עודכנה בהצלחה");
            navigate(`/donors/${donorId}`);
        } catch (e) {
            alert("שגיאה בעדכון תרומה");
        }
    };

    const handleCreditSuccess = async (data) => {
        try {
            await update_donation_by_id(donationId, data);
            alert("הסליקה בוצעה בהצלחה");
            navigate(`/donors/${donorId}`);
        } catch (e) {
            alert("שגיאה בשמירת סליקה");
        }
    };

   
    const logic = useDonationLogic({
        formData: formData, 
        setFormData,
        updating: true,
        onCreditSuccess: handleCreditSuccess
    });


    useEffect(() => {
        const fetchDonation = async () => {
            try {
                const donation = await get_donation_by_id(donationId);
                if (!donation) {
                    setError("לא נמצאה תרומה עם המזהה הזה.");
                    return;
                }

                let cardName = donation.cardHolderName;
                if (donation.paymentMethod === "credit" && donation.providerTransactionId) {
                    const card = await get_masked_card(donationId);
                    if (card) {
                        cardName = `${card.brand} **** ${card.last4} (${card.exp_month}/${card.exp_year})`;
                    }
                }

                setFormData({
                    ...donation,
                    date: donation.date ? donation.date.slice(0, 10) : "",
                    cardHolderName: cardName || "",
                });
            } catch (e) {
                setError("טעינת הנתונים נכשלה.");
            } finally {
                setLoading(false);
            }
        };
        fetchDonation();
    }, [donationId]);

  
    if (!donorId) return <div className="donation-page">תורם לא קיים</div>;
    if (loading) return <div className="donation-page">טוען את הנתונים...</div>;
    if (error) return <div className="donation-page error">{error}</div>;

    return (
        <div className="donation-page">
           <div className="top-buttons-container">
                {/* כפתור חזרה דף אחורה - עם חץ */}
                <button className="round-nav-btn" onClick={() => navigate(-1)} title="חזרה">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>
                {/* כפתור דף הבית - עם בית */}
                <button className="round-nav-btn" onClick={() => navigate('/main_screen')} title="דף הבית">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                        <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
                    </svg>
                </button>
            </div>

            <h2 style={{ color: '#150F6B' }}>עדכון תרומה</h2>

            <DonationForm
                formData={formData}
                updating={true}
                logic={logic}
                onSubmit={handleSubmit}
            />
        </div>
    );
};

export default UpdateDonation;